import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import axios from "axios";
import axiosInstance from "../../instance";
import { BASE_URL } from "../../config/constant";

// const url = process.env.REACT_APP_API_BASE_URL;

const initialState = {
  authLoading: false,
  user: {},
  jobSeekeruser: {},
  isLoggedIn: true,
  token: "",
  tokenJobSeeker: "",
  users: [],
  current: 0,
  myUsersData: [],
  usersLoading: false,
  permissionData: [],
  loading: false,
  forgotAcc: {},
  saving: false,
  singleUser: {},
  rolesData: [],
  userProfile: [],
  usersCount: 0,

  data: {},
  count: {},
  loading: false,
};

export const save = createAsyncThunk(
  "user/save",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    try {
      const response = await axios.post(`/${saveUrl}`, data);
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const saveOutToken = createAsyncThunk(
  "saveSlice/save/saveOutToken",
  async (data, { rejectWithValue, getState }) => {
    let saveUrl = data.url;
    delete data.url;

    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      const state = getState();
      const token = state.auth?.tokenJobSeeker;

      const response = await axiosInstance.post(`/${saveUrl}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.data.success) {
        return rejectWithValue(response.data);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const login = createAsyncThunk("authSlice/login", async (data) => {
  const res = await axios
    .post(`/usr/post_authenticate_user.action`, data)
    .then((res) => res?.data);
  return res;
});

export const fetchMyUsers = createAsyncThunk(
  "saveSlice/fetch/fetchMyUsers",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    try {
      const response = await axiosInstance.post(`/${saveUrl}`, data);
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchPermissions = createAsyncThunk(
  "user/fetchPermissions",
  async (data) => {
    const res = await axiosInstance
      .get(`/api/v2/users/permission/${data?.role}`)
      .then((res) => res.data?.data?.result);
    return res;
  }
);

export const resetPassword = createAsyncThunk(
  "user/resetPassword",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    try {
      const response = await axios.patch(`/${saveUrl}`, data);
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const resendOtp = createAsyncThunk(
  "authSlice/resendOtp",
  async (data) => {
    const res = await axios
      .post(`/auth/resendOtp.action`, data)
      .then((res) => res.data);
    return res;
  }
);

export const verifyOtp = createAsyncThunk(
  "authSlice/verifyOtp",
  async (data) => {
    const res = await axios
      .post(`/auth/verifyOtp.action`, data)
      .then((res) => res.data);
    return res;
  }
);

export const updateUser = createAsyncThunk(
  "authSlice/updateUser",
  async (data) => {
    const res = await axios
      .post(`/auth/saveUser.action`, data)
      .then((res) => res.data);
    return res;
  }
);

export const saveOtp = createAsyncThunk("saveSlice/saveOtp", async (data) => {
  let saveUrl = data.url;
  delete data.url;
  const res = await axios.post(`/${saveUrl}`, data).then((res) => res?.data);
  return res;
});

export const fetchRoles = createAsyncThunk("user/fetchRoles", async (data) => {
  const res = await axiosInstance
    .get(`/api/v2/users/roles`)
    .then((res) => res.data?.data?.result);
  return res;
});

export const fetchMyProfile = createAsyncThunk(
  "user/fetchMyProfile",
  async (data) => {
    const res = await axiosInstance
      .get(`/api/v2/users/me`)
      .then((res) => res.data?.data?.response);
    return res;
  }
);

export const getUserActivities = createAsyncThunk(
  "usr/getUserActivities",
  async (data) => {
    const res = await axiosInstance
      .get(`/usr/getUserActivities.action`)
      .then((res) => res.data?.data?.response);
    return res;
  }
);

export const fetchData = createAsyncThunk(
  "fetch/fetchData",
  async (data, { rejectWithValue }) => {
    const { url, ...body } = data;

    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      const response = await axios({
        url,
        method: "POST",
        data: Object.keys(body).length ? body : null,
      });
      if (!response.data.success) {
        return {
          key: url,
          data: [],
          total: 0,
        };
      }

      return {
        key: url,
        data: response?.data?.data?.result,
        total: response?.data?.total,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const saveFile = createAsyncThunk("saveSlice/saveFile", async (data) => {
  const res = await axios
    .post(`/v1/api/att/upload`, data, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
  return res;
});

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = {};
      state.isLoggedIn = false;
      state.token = ""; 
      localStorage.clear();
    },
    setToken: (state, action) => {
      state.token = action.payload;
      state.isLoggedIn = true;
    },
    setTokenSeeker: (state, action) => {
      state.tokenJobSeeker = action.payload;
    },

    setUser: (state, action) => {
      state.user = action.payload;
    },
    setJobSeekerUser: (state, action) => {
      state.jobSeekeruser = action.payload;
    },
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    cleanForgotAcc: (state, action) => {
      state.forgotAcc = initialState.forgotAcc;
    },
    cleanSingleUser: (state) => {
      state.singleUser = initialState.singleUser;
    },
    clearAuthObj: () => {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(login.pending, (state) => {
        state.authLoading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.authLoading = false;
        state.user = action?.payload?.messages?.message;
        state.isLoggedIn = true;
      })
      .addCase(login.rejected, (state) => {
        state.authLoading = false;
        state.isLoggedIn = false;
      })

      .addCase(fetchMyUsers.pending, (state) => {
        state.usersLoading = true;
      })
      .addCase(fetchMyUsers.fulfilled, (state, action) => {
        state.usersLoading = false;
        state.myUsersData = action.payload?.data?.result;
        state.usersCount = action.payload.total;
      })
      .addCase(fetchMyUsers.rejected, (state) => {
        state.usersLoading = false;
        state.myUsersData = [];
        state.usersCount = 0;
      })

      .addCase(fetchPermissions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.permissionData = action.payload?.[0];
      })
      .addCase(fetchPermissions.rejected, (state) => {
        state.loading = false;
        state.permissionData = [];
      })

      .addCase(verifyOtp.pending, (state) => {
        state.authLoading = true;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.authLoading = false;
        state.user = action.payload?.jsonData;
      })
      .addCase(verifyOtp.rejected, (state) => {
        state.authLoading = false;
        state.user = {};
      })

      .addCase(updateUser.pending, (state) => {
        state.authLoading = true;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.authLoading = false;
      })
      .addCase(updateUser.rejected, (state) => {
        state.authLoading = false;
      })

      .addCase(resendOtp.pending, (state) => {
        state.authLoading = true;
      })
      .addCase(resendOtp.fulfilled, (state, action) => {
        state.authLoading = false;
        state.user = action.payload?.jsonData;
      })
      .addCase(resendOtp.rejected, (state) => {
        state.authLoading = false;
        state.user = {};
      })

      .addCase(saveOtp.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveOtp.fulfilled, (state, action) => {
        state.saving = false;
      })
      .addCase(saveOtp.rejected, (state) => {
        state.saving = false;
      })

      .addCase(resetPassword.pending, (state) => {
        state.saving = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.saving = false;
        state.forgotAcc = action.payload?.data?.result;
      })
      .addCase(resetPassword.rejected, (state) => {
        state.saving = false;
      })

      .addCase(save.pending, (state) => {
        state.saving = true;
      })
      .addCase(save.fulfilled, (state, action) => {
        state.saving = false;
        state.singleUser = action?.payload?.data?.result;
      })
      .addCase(save.rejected, (state) => {
        state.saving = false;
      })

      .addCase(saveOutToken.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveOutToken.fulfilled, (state, action) => {
        state.saving = false;
        state.singleUser = action?.payload?.data?.result;
      })
      .addCase(saveOutToken.rejected, (state) => {
        state.saving = false;
      })

      

      .addCase(fetchRoles.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.rolesData = action.payload;
      })
      .addCase(fetchRoles.rejected, (state) => {
        state.loading = false;
        state.rolesData = [];
      })

      .addCase(fetchMyProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMyProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.userProfile = action.payload?.[0];
      })
      .addCase(fetchMyProfile.rejected, (state) => {
        state.loading = false;
        state.userProfile = [];
      })
      .addCase(getUserActivities.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserActivities.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getUserActivities.rejected, (state) => {
        state.loading = false;
      })

      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        const { key, data, total } = action.payload;

        if (!state.data) state.data = {};
        if (!state.count) state.count = {};

        state.data = { ...state.data, [key]: data || [] };
        state.count = { ...state.count, [key]: total || 0 };
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false;
        const key = action.payload?.key || "unknown";

        if (!state.data) state.data = {};
        if (!state.count) state.count = {};

        state.data = { ...state.data, [key]: [] };
        state.count = { ...state.count, [key]: 0 };
      })

      .addCase(saveFile.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveFile.fulfilled, (state, action) => {
        state.saving = false;
      })
      .addCase(saveFile.rejected, (state) => {
        state.saving = false;
      });
  },
});

export default authSlice.reducer;
export const {
  logout,
  setToken,
  setTokenSeeker,
  setUser,
  setJobSeekerUser,
  setIsLoggedIn,
  cleanForgotAcc,
  cleanSingleUser,
  clearAuthObj,
} = authSlice.actions;
